document.addEventListener("DOMContentLoaded", () => {
  const formErrors = document.querySelectorAll(".formError");

  formErrors.forEach((errorEl) => {
    const isVisible = window.getComputedStyle(errorEl).display !== "none";
    const rect = errorEl.getBoundingClientRect();
    const isOnScreen =
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <=
        (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth);

    if (isVisible && isOnScreen) {
      const formGroup = errorEl.closest(".form-group");
      if (formGroup) {
        formGroup.style.marginBottom = "40px";
      }
    } else {
      const formGroup = errorEl.closest(".form-group");
      if (formGroup) {
        formGroup.style.marginBottom = "";
      }
    }
  });
});
